import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// import pages
import MemberList from "./MemberList";
import Chatbox from "./Chatbox";

// import utils
import { socket } from "../../untils/socket";
import isEmpty from "../../validations/is-empty";
import apiClient from "../../actions/api";

// import style
import "../../style/chat/chat.scss";

const ChatPage = ({ title }) => {
  document.title = title;

  const authUser = useSelector((state) => state.auth.user);
  const themeMode = useSelector((state) => state.themeMode);
  const [selectedChat, setSelectedChat] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [joinedUsers, setJoinedUsers] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [unreadCounts, setUnreadCounts] = useState({
    directMessages: {},
    channels: {},
  });

  const markConversationRead = (type, id) => {
    const key = type === "dm" ? "directMessages" : "channels";
    setUnreadCounts((current) => ({
      ...current,
      [key]: { ...current[key], [id]: 0 },
    }));
  };

  useEffect(() => {
    if (!authUser?._id) return;
    apiClient
      .get(`/chats/unread-counts/${authUser._id}`)
      .then((res) => setUnreadCounts(res.data))
      .catch(() => {});
  }, [authUser]);

  useEffect(() => {
    socket.on("online_users", (userIds) => setOnlineUsers(userIds));
    socket.on("user_online", (data) =>
      setOnlineUsers((prev) => [...new Set([...prev, data.userId])]),
    );
    socket.on("user_offline", (data) =>
      setOnlineUsers((prev) => prev.filter((id) => id !== data.userId)),
    );
    const handleGroupUnread = (data) => {
      if (
        data.senderId === authUser?._id ||
        (selectedChat?.type === "group" && selectedChat.id === data.roomId)
      )
        return;
      setUnreadCounts((current) => ({
        ...current,
        channels: {
          ...current.channels,
          [data.roomId]: (current.channels?.[data.roomId] || 0) + 1,
        },
      }));
    };
    const handleDmUnread = (data) => {
      if (
        data.senderId === authUser?._id ||
        (selectedChat?.type === "dm" && selectedChat.id === data.senderId)
      )
        return;
      setUnreadCounts((current) => ({
        ...current,
        directMessages: {
          ...current.directMessages,
          [data.senderId]: (current.directMessages?.[data.senderId] || 0) + 1,
        },
      }));
    };
    socket.on("receive_message", handleGroupUnread);
    socket.on("receive_dm", handleDmUnread);

    return () => {
      socket.off("online_users");
      socket.off("user_online");
      socket.off("user_offline");
      socket.off("receive_message", handleGroupUnread);
      socket.off("receive_dm", handleDmUnread);
    };
  }, [authUser, selectedChat]);

  useEffect(() => {
    if (isEmpty(authUser) || !authUser._id) return undefined;

    const registerUser = () => {
      if (isEmpty(authUser) || !authUser._id) return;

      const currentUser = {
        _id: authUser._id,
        name: authUser.name,
        email: authUser.email,
      };

      socket.emit("register_user", currentUser);
    };

    socket.on("connect", registerUser);

    if (socket.connected) {
      registerUser();
    } else {
      socket.connect();
    }

    return () => {
      socket.off("connect", registerUser);
      socket.disconnect();
    };
  }, [authUser]);

  return (
    <div
      className={`chat-section ${
        themeMode.themeMode ? "chat-section-dark" : "chat-section-light"
      }`}
    >
      <MemberList
        setSelectedChat={setSelectedChat}
        selectedChat={selectedChat}
        onlineUsers={onlineUsers}
        setJoinedUsers={setJoinedUsers}
        setGroupList={setGroupList}
        unreadCounts={unreadCounts}
        markConversationRead={markConversationRead}
      />
      <Chatbox
        selectedChat={selectedChat}
        joinedUsers={joinedUsers}
        groupList={groupList}
        onlineUsers={onlineUsers}
        markConversationRead={markConversationRead}
      />
    </div>
  );
};

export default ChatPage;
